import { IReportTransactionResponse, ReceiptResponse } from '@bciti/types';
import { Observable } from 'rxjs';

export abstract class ReportsService {
    abstract getReceipts(startDate: Date, endDate: Date): Observable<IReportTransactionResponse[]>;
    abstract getReceiptsCSV(startDate: Date, endDate: Date): Observable<IReportTransactionResponse[]>;
}
